import React from 'react';
import PropTypes from 'prop-types';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import PageHeader from './PageHeader';

const AdminPageHero = ({ title, subtitle, actions = null, metrics = [] }) => {
  const theme = useTheme();

  return (
    <>
      <PageHeader title={title} subtitle={subtitle} actions={actions} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', lg: 'row' },
          alignItems: { xs: 'flex-start', lg: 'center' },
          justifyContent: 'space-between',
          gap: 2,
          mb: 0.5,
        }}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              letterSpacing: '-0.03em',
              lineHeight: 1.1,
              mb: 0.6,
            }}
          >
            {title}
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{
              maxWidth: 760,
              fontSize: '0.95rem',
            }}
          >
            {subtitle}
          </Typography>
        </Box>

        {(actions || metrics?.length) ? (
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.2}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            justifyContent="flex-end"
            sx={{ width: { xs: '100%', lg: 'auto' } }}
          >
            {metrics?.length ? (
              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                {metrics.map((metric) => (
                  <Chip
                    key={`${metric.label}-${metric.value}`}
                    size="small"
                    label={`${metric.label}: ${metric.value}`}
                    sx={{
                      height: 28,
                      fontWeight: 700,
                      borderRadius: 6,
                      color: 'text.primary',
                      border: `1px solid ${alpha(theme.palette.divider, 0.8)}`,
                      backgroundColor: alpha(theme.palette.primary.main, 0.06),
                    }}
                  />
                ))}
              </Stack>
            ) : null}
            {actions}
          </Stack>
        ) : null}
      </Box>
    </>
  );
};

AdminPageHero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  actions: PropTypes.node,
  metrics: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    })
  ),
};

export default AdminPageHero;
